<template lang="html">
  <main>
    <mobile-header />
    <sidebar/>

    <div id="wrapper" :class="{ 'minimized-sidebar': minimized }">
      <transition name="anim">
        <router-view id="main"/>
      </transition>
    </div>

    <transition name="modal-fade-scale">
      <AddCrop v-if="$store.getters['modals/add-crop/isOpened']"/>
    </transition>

    <!-- <transition name="fade">
      <Alert v-if="$store.getters['modals/alert/isOpened']"/>
    </transition> -->

    <transition name="modal-fade-scale">
      <Prompt v-if="$store.getters['modals/prompt/isOpened']"/>
    </transition>

  </main>
</template>

<script>
import MobileHeader from '@/components/common/mobile/MobileHeader'
import Sidebar from '@/components/common/sidebar/Sidebar'
import AddCrop from '@/components/common/modals/AddCrop'
import Prompt from '@/components/common/modals/Prompt'
import { mapGetters } from 'vuex'


export default {
  components: {
    Sidebar,
    MobileHeader,
    AddCrop,
    Prompt,
  },
  computed: {
    ...mapGetters({
      user: 'user/data',
      minimized: 'sidebar/minimized',
      active: 'sidebar/active',
    })
  },

  created() {
    this.$listenNote('plan/subs/update', data => {
      this.$store.commit('user/saveSubsStatus', data.status);
    });

    if(!this.user.isPasswordSet) {
      this.$store.commit('modals/alert/open', {
        text: 'Please, set your password before you start using the software',
        onClose: () => {
          this.$router.push('/dashboard/account');
        }
      });
    }
  },

  // Аннигилировать из кода
  // mounted() {
  //   this.$store.dispatch('farms/updateData').then(res => {
  //     console.log('---------', this.$store.getters['farms/fields']);
  //   });
  // }
}
</script>

<style lang="scss" scoped>
#wrapper {
  padding: 8px;
  box-sizing: border-box;
}
#main {
  &.anim {
    &-enter {
      transform: translateY(50px);
      opacity: 0;
    }
    &-enter-to {
      transform: translateY(0);
      opacity: 1;
    }
    &-leave-active {
      display: none;
    }
    &-enter-active {
      transition: transform 0.5s ease, opacity 0.5s ease;
    }
  }
}

@media (min-width: 1101px) {
  #wrapper {
    &.minimized-sidebar {
      width: calc(100% - 80px);
    }
  }
}

</style>
